import { SignInPageComponent } from '@seen/react'
import type { JSX } from 'react'
import { useNavigate } from 'react-router'
import {
  IS_PROD,
  MEDPLUM_GOOGLE_CLIENT_ID,
  MEDPLUM_PROJECT_ID,
} from '#src/config.ts'

export function SignInPage(): JSX.Element {
  const navigate = useNavigate()
  return (
    <SignInPageComponent
      medplumProjectId={MEDPLUM_PROJECT_ID}
      medplumGoogleClientId={MEDPLUM_GOOGLE_CLIENT_ID}
      onSignIn={() => navigate('/')}
      disableEmailAuth={IS_PROD}
    />
  )
}
